module.exports = __webpack_public_path__ + "img/reaction_card.e11d5ad7.svg";